import React from 'react'

function Header() {
    return (
         <div className="header">
             <img src="https://www.google.com/images/icons/product/keep-512.png" alt="logo" height="70" width ="70"/>
            <h4>Google Keep clone</h4>
         </div>
    )
}

export default Header
